// 20.01.19 - This file is the main entry point of our application that actually renders the react app in the dom.
import * as React from "react";
import * as ReactDOM from "react-dom";
import App from "./App";
import "./index.css";
import * as Sentry from "@sentry/react";
// import registerServiceWorker from "./registerServiceWorker";

// This code is a fix for a bug in redux dev tools -- it does not activate when
// the code is built for production

Sentry.init({
  dsn: `${(window as any).sentryDsnUrl}`,
  environment: `${(window as any)?.sentryEnvironment}`,
  integrations: [new Sentry.BrowserTracing()],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,
});

if (process.env.NODE_ENV !== "production") {
  (Map.prototype as any).toJSON = function() {
    const obj: any = {};
    this.forEach((value: any, key: any) => (obj[key] = value));
    return obj;
  };
}

ReactDOM.render(<App />, document.getElementById("root") as HTMLElement);
// registerServiceWorker();
